import React, { useEffect, useState } from 'react';
import {
  arrayOf,
  bool,
  func,
  node,
  oneOf,
  oneOfType,
  string
} from 'prop-types';
import classNames from 'classnames';

import { SampleImage } from './components/SampleImage';
import { SampleFooter } from './components/SampleFooter';
import './sample.scss';

export const Sample = ({
  channel,
  children,
  className,
  imageUrl,
  onClick,
  selectable,
  selected,
  selectButton,
  touchDevice
}) => {
  const [hovered, setHovered] = useState(false);
  const [clicked, setClicked] = useState(selected);

  useEffect(() => {
    // selected prop takes priority
    if (selected !== clicked) {
      setClicked(selected);
      if (!touchDevice) {
        setHovered(selected);
      }
    }
  }, [clicked, selected]);

  const SelectCTA = () => {
    return (
      <div className="sample__select-cta">
        <span className="sample__select-cta__text">Select</span>
      </div>
    );
  };

  const swatchSelected = clicked || hovered;
  const swatchCardClasses = classNames(className, 'sample', {
    'sample--selected': swatchSelected
  });
  const shouldShowSelectButton = hovered && !clicked && selectButton;

  const handleHover = () => {
    if (selectable && !clicked) {
      setHovered(!hovered);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
      setClicked(!clicked);
    }
  };

  return (
    <button
      type="button"
      className="sample__button"
      onClick={handleClick}
      onMouseEnter={!touchDevice ? handleHover : null}
      onMouseLeave={!touchDevice ? handleHover : null}
    >
      <div className={swatchCardClasses}>
        <SampleImage className="sample__sample-image" channel={channel} url={imageUrl}>
          {shouldShowSelectButton && <SelectCTA />}
        </SampleImage>
        <SampleFooter channel={channel}>
          {children}
        </SampleFooter>
      </div>
    </button>
  );
};

Sample.displayName = 'Sample';

Sample.propTypes = {
  channel: oneOf(['desktop', 'mobile', 'tablet']),
  children: oneOfType([node, arrayOf(node)]),
  className: string,
  imageUrl: string.isRequired,
  onClick: func,
  selectable: bool,
  selected: bool,
  selectButton: bool,
  touchDevice: bool
};

Sample.defaultProps = {
  channel: 'desktop',
  children: null,
  className: null,
  onClick: null,
  selectable: false,
  selected: false,
  selectButton: false,
  touchDevice: false
};
